<template>
  <layout-basic>
      <v-container id="billing-sec">
        <v-row>
          <v-col class="Full-Course-Library-Title">
            Account Status : {{ company.state_description }}
          </v-col>
        </v-row>
        <v-row v-if="canBuyImprove">
          <v-col cols="12">
            <p>
              Choose your IMPROVE plan and complete secure checkout with Stripe.
            </p>
            <v-btn color="primary" large depressed to="/billing">
              Get started / Buy IMPROVE
            </v-btn>
          </v-col>
        </v-row>
      </v-container>
  </layout-basic>
</template>
<script>
import LayoutBasic from "@/layouts/Dashboard";
import companyAPI from "@/api/company.js";
import { EventBus } from "@/event-bus.js";
export default {
  name: "Profile",
  components: {
    LayoutBasic
  },
  data() {
    return {
      company: [],
      params: ""
    };
  },
  computed: {
    canBuyImprove: function() {
      return this.company.state == 1 || this.company.state == 2 || this.company.state == 4;
    }
  },
  mounted() {
    this.getAccountInfo();
    this.setEventBus();
  },
  methods: {
    getAccountInfo() {
      companyAPI.getAccountInfo().then(response => {
        this.company = response.data.data;
      });
    },
    setEventBus() {
      EventBus.$on("COMPANY_UPDATED", () => {
        this.getAccountInfo();
      });
    }
  }
};
</script>
